import { useCountUp } from "../lib/useCountUp.js";

interface Props {
  score: number;
  run: boolean;
  color: string;
}

export function PipMeter({ score, run, color }: Props) {
  const val = useCountUp(score, run, 1300);
  const filled = Math.round(val / 10);
  return (
    <div className="pipmeter">
      <div className="pips">
        {Array.from({ length: 10 }).map((_, i) => (
          <span
            key={i}
            className="pip"
            style={{ background: run && i < filled ? color : "var(--card)" }}
          />
        ))}
      </div>
      <span className="gdisplay pip-num" style={{ color }}>
        {val}
        <span className="pip-denom gmono">/100</span>
      </span>
    </div>
  );
}
